import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnSearchListTemplateOptions } from './search-list-template-options.interface';

export interface ISnSearchListFormFieldConfig<M = any> extends FormlyFieldConfig {
  type: 'search-list';
  templateOptions?: ISnSearchListTemplateOptions<M>;
}
